export const name = "UNICODE";
export const summary = `Gets the Unicode code point for the first character in a value.`;
export const reference = `
## UNICODE

Gets the Unicode code point for the first character in a value.

\`\`\`
UNICODE(value)
\`\`\`

### Description

Returns the Unicode code point for the first character in\`value\`. Returns \`0\` if \`value\` is empty, or if the resulting Unicode code point is \`0\`.


### Return type

\`INT64\`


### Examples



\`\`\`
SELECT UNICODE('âbcd') as A, UNICODE('â') as B, UNICODE('') as C, UNICODE(NULL) as D;

/*-------+-------+-------+-------*
 | A | B | C | D |
 +-------+-------+-------+-------+
 | 226 | 226 | 0 | NULL |
 *-------+-------+-------+-------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
